export const SEVERITIES = ['Normal', 'Warning', 'Alert'];

export const SEVERITY_ICONS = {
  Normal: 'he-statushealthy',
  Warning: 'he-statusrisk',
  Alert: 'he-statusrisk',
};

export const SEVERITY_COLORS = {
  Normal: 'rgb(12, 169, 25)',
  Warning: 'rgb(255, 200, 0)',
  Alert: 'rgb(240, 48, 64)',
};

export const DELIVERY_OPTIONS = [
  { value: 'email', label: 'Email' },
  { value: 'app', label: 'In app' },
];

export const DELIVERY_FILTER_OPTIONS = DELIVERY_OPTIONS.map((options) => ({
  value: options.value,
  label: options.label,
}));

export const DEFAULT_STATE_CHANGE_SETTINGS = {
  Normal: { app: false, email: false },
  Warning: { app: true, email: true },
  Alert: { app: true, email: true },
};

// Per-role default configs
const ROLE_DEFAULTS_SITE_MANAGER = {
  stateChangeSettings: {
    Normal: { app: false, email: false },
    Warning: { app: true, email: true },
    Alert: { app: true, email: true },
  },
};

const ROLE_DEFAULTS_VIEWER = {
  stateChangeSettings: {
    Normal: { app: false, email: false },
    Warning: { app: true, email: false },
    Alert: { app: true, email: false },
  },
};

const ROLE_DEFAULTS_OTHER = { ...ROLE_DEFAULTS_VIEWER };

export const getRoleDefaults = (roleType) => {
  if (roleType === 'Site Manager') return ROLE_DEFAULTS_SITE_MANAGER;
  return ROLE_DEFAULTS_OTHER;
};

export const isConfigCustom = (roleType, config) => {
  if (!config) return false;
  const defaults = getRoleDefaults(roleType);
  return SEVERITIES.some((sev) => {
    const current = config.stateChangeSettings?.[sev];
    const defaultSetting = defaults.stateChangeSettings[sev];
    if (!current || !defaultSetting) return true;
    return current.app !== defaultSetting.app || current.email !== defaultSetting.email;
  });
};
